import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function getTokenByName(name) {
  return Cookies.get(name)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function clearToken(token) {
  return Cookies.remove(token)
}
export function getStroage(_key) {
  return window.localStorage.getItem(_key)
}

export function setStroage(_key, _val) {
  return window.localStorage.setItem(_key, _val)
}

export function removeStroage(_key) {
  return window.localStorage.removeItem(_key)
}
//清除指定本地缓存 localstorage
export function removeStorage (_key) {
  try {
    window.localStorage.removeItem(_key)
  } catch (error) {

  }
}
